import {apiRequest} from "./client";
import type {AnalyticsResponse} from "./types";

export async function setStockNotification(data: {id: number; email: string}): Promise<{ok: boolean; message?: string; code?: string}> {
  return apiRequest<{ok: boolean; message?: string; code?: string}>("/stock-notifications", {method: "POST", body: data});
}

export async function cancelStockNotification(productId: number): Promise<{ok: boolean}> {
  return apiRequest<{ok: boolean}>(`/stock-notifications/${productId}`, {method: "DELETE"});
}

export async function setOnlyStock(): Promise<{onlyStock: boolean}> {
  return apiRequest<{onlyStock: boolean}>("/session/only-stock", {method: "POST"});
}

export async function clearOnlyStock(): Promise<{onlyStock: boolean}> {
  return apiRequest<{onlyStock: boolean}>("/session/include-no-stock", {method: "POST"});
}

export async function getAnalytics(): Promise<AnalyticsResponse> {
  return apiRequest<AnalyticsResponse>("/integrations/analytics");
}
